"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initRteConfig = initRteConfig;

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _loggers = require("customer-data-tracking/loggers");

var _requireAsync = _interopRequireDefault(require("crm_ui/utils/requireAsync"));

var _AtMentionInviteZeroStateOptions = _interopRequireDefault(require("./AtMentionInviteZeroStateOptions"));

var _VidyardStore = _interopRequireDefault(require("crm_ui/extensions/vidyard/VidyardStore"));

var logCommunicatorInteraction = function logCommunicatorInteraction(pluginAction) {
  return function () {
    return _loggers.CrmLogger.log('record-interaction', {
      action: 'communicator interaction',
      subAction: pluginAction
    });
  };
};

var logCommunicatorEvent = function logCommunicatorEvent(action) {
  var interactionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';

  _loggers.CommunicatorLogger.log('communicatorInteraction', {
    action: action,
    activity: interactionType,
    channel: interactionType === 'call' ? 'outbound call' : interactionType,
    source: 'communicator window'
  });
};

var tracker = function tracker(type) {
  var interactionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  return function (eventKey) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _loggers.CrmLogger.log(eventKey, options);

    logCommunicatorEvent("insert " + type, interactionType);
  };
};

function initRteConfig(interactionType) {
  (0, _requireAsync.default)('hubspot.customerdata.rte.config.RichTextEditorDefaultConfigurations').then(function (_ref) {
    var initializeRteConfig = _ref.initializeRteConfig;

    var hasToolbarBeta = _IsUngatedStore.default.get('CRM:EnableNewRichTextToolbar');

    initializeRteConfig({
      hasToolbarBeta: hasToolbarBeta,
      hasVideo: !hasToolbarBeta && _ScopesContainer.default.isScoped('one-to-one-video'),
      hasShepherdVideoUngated: _IsUngatedStore.default.get('CRM:Shepherd1:1Video') && _VidyardStore.default.get(),
      handleVideoTracking: {
        openedVideo: function openedVideo() {
          logCommunicatorEvent('click video', interactionType);
        },
        onInsertVideo: function onInsertVideo() {
          logCommunicatorEvent('insert video', interactionType);
        },
        openVidyardModalFromShepherd: logCommunicatorInteraction('open Get a free Vidyard account modal from shepherd popover'),
        closeShepherdPopover: logCommunicatorInteraction('close vidyard shepherd popover'),
        clickAcademyResources: logCommunicatorInteraction('click academy resources'),
        vidyardModalOpen10Secs: logCommunicatorInteraction('vidyard modal open 10s+')
      },
      atMentions: {
        dataProp: 'owners',
        useInviteZeroState: _ScopesContainer.default.getContainer().get()['manage-users-access'],
        inviteZeroStateOpts: _AtMentionInviteZeroStateOptions.default
      },
      link: {
        onInsertLink: function onInsertLink() {
          logCommunicatorEvent('insert link', interactionType);
        },
        onOpenPopover: function onOpenPopover() {
          logCommunicatorInteraction('insert link')();
          logCommunicatorEvent('click link', interactionType);
        }
      },
      snippets: {
        tracker: tracker('snippet', interactionType),
        onOpenPopover: function onOpenPopover() {
          logCommunicatorInteraction('insert snippet')();
          logCommunicatorEvent('click snippet', interactionType);
        }
      },
      knowledgeArticles: {
        tracker: tracker('knowledge article', interactionType),
        enabled: _ScopesContainer.default.getContainer().get()['service-knowledge-access'],
        onOpenPopover: function onOpenPopover() {
          logCommunicatorInteraction('insert knowledge article')();
          logCommunicatorEvent('click knowledge article', interactionType);
        }
      },
      image: {
        onOpenPopover: function onOpenPopover() {
          logCommunicatorEvent('click image', interactionType);
        },
        onInsertImage: function onInsertImage() {
          logCommunicatorEvent('insert image', interactionType);
        }
      },
      formattingPluginGroup: {
        onOpenPopover: function onOpenPopover() {
          logCommunicatorInteraction('format text')();
          logCommunicatorEvent('click to format text', interactionType);
        }
      }
    });
  });
}